module.exports = __webpack_public_path__ + "img/code.b3c3cb74.svg";